import Typography, { TypographyProps } from '@material-ui/core/Typography'
import { Theme, makeStyles } from '@material-ui/core/styles'
import { ElementType } from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    text: { color: theme.custom.colors.darkGrey }
}))

type StaticPageWrapperBodyTypographyProps = Pick<
    TypographyProps,
    'variant' | 'children'
> & { component?: ElementType }

const StaticPageWrapperBodyTypography = ({
    variant,
    component,
    children
}: StaticPageWrapperBodyTypographyProps) => {
    const { text } = useStyles()

    return (
        <Typography className={text} align="center" variant={variant}>
            {children}
        </Typography>
    )
}

export default StaticPageWrapperBodyTypography
